import { Pipe, PipeTransform } from '@angular/core';
import { StatusWniosku } from '@interfaces/stypendia/status-wniosku.enum';

@Pipe({
  name: 'statusWniosku',
})
export class StatusWnioskuPipe implements PipeTransform {
  transform(value: StatusWniosku): string {
    switch (value) {
      case StatusWniosku.Robocze:
      case StatusWniosku.DoSkompletowania:
      case StatusWniosku.CofnietoDoEdycji:
      case StatusWniosku.CofnietoDoUzupelnienia:
        return 'bg-warning text-secondary';
      case StatusWniosku.PostanowionoBezRozpoznania:
      case StatusWniosku.Wycofano:
      case StatusWniosku.Odrzucono:
        return 'bg-danger';
      default:
        return 'bg-success';
    }
  }
}
